"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MAX_MILLISECONDS = exports.SYSTEM_CONFIG_DOC_ID = void 0;
exports.SYSTEM_CONFIG_DOC_ID = 'config';
exports.MAX_MILLISECONDS = 7978758988368;
